// setMediaHeightInPostFeed.js
'use strict';
import { ADD_MESSAGES } from '../ActionTypes.js';

/**
 * Set media height in post feed
 * @kind action
 * @param {string} {messageId} - message id.
 * @param {HTMLElement} {imageElement} - image element.
 * @param {HTMLElement} {mediaWrapperElement} - media wrapper element.
 * @return {Promise} Action promise.
 */
const setMediaHeightInPostFeed =
  ({ messageId, imageElement, mediaWrapperElement } = {}) =>
  async dispatch => {
    if (!imageElement || !messageId || !mediaWrapperElement) {
      return dispatch({ type: '' });
    }
    const width = imageElement.naturalWidth;
    const height = imageElement.naturalHeight;
    const aspectRatio = Math.min(Math.max(width / height, 9 / 16), 16 / 9);
    let mediaHeight = mediaWrapperElement.clientWidth / aspectRatio;
    if (isNaN(mediaHeight)) mediaHeight = mediaWrapperElement.clientHeight;
    return dispatch({
      type: ADD_MESSAGES,
      payload: {
        messages: {
          [messageId]: {
            id: messageId,
            mediaHeightInPostFeed: mediaHeight,
          },
        },
      },
    });
  };

export default setMediaHeightInPostFeed;
